import { useEffect } from 'react'

import { useMarkTeamReadMutation } from 'features/TeamChat/api/teamChat.api'
import { MARK_READ_DELAY_MS } from 'features/TeamChat/teamChat.constants'

import { useDocumentVisible } from './useDocumentVisible'

type Args = { lastId?: number; lastReadId?: number | null }

// Runs only while the chat is on screen; a hidden browser tab marks nothing read.
export const useMarkRead = ({ lastId, lastReadId }: Args): void => {
  const visible = useDocumentVisible()
  const [markRead] = useMarkTeamReadMutation()

  useEffect(() => {
    if (!visible || !lastId || lastId === lastReadId) return
    const timer = setTimeout(() => markRead({ last_read_message_id: lastId }), MARK_READ_DELAY_MS)
    return () => clearTimeout(timer)
  }, [visible, lastId, lastReadId, markRead])
}
